import { Button } from "@bokio/designsystem/components/Button";
import { AccountingLangFactory } from "@bokio/lang";
import { useCompanyInfo } from "@bokio/mobile-web-shared/core/contexts/CompanyInfoContext/CompanyInfoContext";
import * as m from "@bokio/mobile-web-shared/core/model/model";
import { getRoute } from "@bokio/shared/route";

import * as styles from "./salaryReceipt.scss";

import ReceiptType = m.Entities.ReceiptType;
interface SalaryReceiptProps {
	type: ReceiptType;
	receiptId: string;
	externalId: string;
}

const getDescription = (type: ReceiptType) => {
	const lang = AccountingLangFactory();
	switch (type) {
		case ReceiptType.Salary:
			return lang.Receipt_PreviewNotAvailable_Salary;
		default:
			return lang.Receipt_PreviewNotAvailable_SalaryTax;
	}
};

const renderButton = (type: ReceiptType, receiptId: string, externalId: string, company: string) => {
	const lang = AccountingLangFactory();
	switch (type) {
		case ReceiptType.Salary:
			return (
				<Button
					type="link"
					appearance="secondary"
					external={true}
					route={getRoute("downloadReceipt", { company, receiptId })}
				>
					{lang.DownloadPDF}
				</Button>
			);
		default:
			return (
				<Button
					type="link"
					appearance="secondary"
					external={true}
					route={getRoute("salaryTaxreportRedirect", { company, reportId: externalId })}
				>
					{lang.Receipt_GoToReport_Salary}
				</Button>
			);
	}
};

export const SalaryReceipt = ({ type, receiptId, externalId }: SalaryReceiptProps) => {
	const {
		companyInfo: { Id: companyId },
	} = useCompanyInfo();
	return (
		<div className={styles.container}>
			<div className={styles.text}>{getDescription(type)}</div>
			{renderButton(type, receiptId, externalId, companyId)}
		</div>
	);
};
